import Papa from "papaparse";

export const normalizeHeader = (value: string) => value.toLowerCase().replace(/[\s_-]/g, "");

const isValidCalendarDate = (year: number, month: number, day: number) => {
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year
        && date.getUTCMonth() === month - 1
        && date.getUTCDate() === day;
};

export const parseDateOnly = (value: string): string | undefined => {
    const trimmed = value.trim();
    const isoDate = /^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.exec(trimmed);
    if (isoDate) {
        const [, year, month, day] = isoDate;
        if (isValidCalendarDate(Number(year), Number(month), Number(day))) return trimmed;
    }

    const dottedDate = /^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.(\d{4})$/.exec(trimmed);
    if (dottedDate) {
        const [, day, month, year] = dottedDate;
        if (isValidCalendarDate(Number(year), Number(month), Number(day))) {
            return `${year}-${month}-${day}`;
        }
    }

    const slashedDate = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/.exec(trimmed);
    if (slashedDate) {
        const [, day, month, year] = slashedDate;
        if (isValidCalendarDate(Number(year), Number(month), Number(day))) {
            return `${year}-${month}-${day}`;
        }
    }

    return undefined;
};

export const parseRows = (fileContent: string) => {
    const parsed = Papa.parse<string[]>(fileContent, {
        skipEmptyLines: "greedy",
    });

    return parsed.data.map((row) => ({
        values: row.map((v) => v.trim()),
    }));
};
